<template>
    <div>
        <common-table :url="url"
                      :table-columns="tableColumns"
                      :form-fields="formFields"
                      :operate="operate"
                      :permission="permission"
                      :searchs="searchs"
                      ref="table"/>

        <!--加减款弹出框-->
        <div class="dialog">
            <el-dialog title="修改积分" :visible.sync="scoreVisible" @close="scoreVisibleClose('scoreForm')"
                       custom-class="common-dialog" :close-on-click-modal="false" width="30%">
                <div class="dialog_body">
                    <el-form label-position="right" status-icon label-width=""
                             :model="scoreForm" ref="scoreForm">

                        <el-form-item label="" prop="current" :rules="[]">
                            <div>
                                <el-input placeholder="当前代理" v-model="scoreForm.username" :style="'pointer-events: none;'">
                                    <template slot="prepend">当前代理</template>
                                </el-input>
                            </div>
                        </el-form-item>

                        <el-form-item label="" prop="current" :rules="[]">
                            <div>
                                <el-input placeholder="当前额度" v-model="scoreForm.current" :style="'pointer-events: none;'">
                                    <template slot="prepend">当前积分</template>
                                </el-input>
                            </div>
                        </el-form-item>

                        <el-form-item label="" prop="score" :rules="[{message: '请输入积分', trigger: 'blur', required: true}]">
                            <div style="margin-top: 15px;">
                                <el-input placeholder="请输入积分" v-model="scoreForm.score" class="input-with-select">
                                    <el-select style="width: 120px" v-model="scoreForm.type" slot="prepend" placeholder="请选择">
                                        <el-option label="加积分" value="1"/>
                                        <el-option label="减积分" value="0"/>
                                    </el-select>
                                </el-input>
                            </div>
                        </el-form-item>

                        <el-form-item label="">
                            <el-radio-group v-model="scoreForm.score" size="small">
                                <el-radio-button border label="1000">1000</el-radio-button>
                                <el-radio-button border label="2000">2000</el-radio-button>
                                <el-radio-button border label="3000">3000</el-radio-button>
                                <el-radio-button border label="5000">5000</el-radio-button>
                                <el-radio-button border label="10000">10000</el-radio-button>
                                <el-radio-button border label="20000">20000</el-radio-button>
                                <el-radio-button border label="30000">30000</el-radio-button>
                            </el-radio-group>
                        </el-form-item>

                        <el-form-item label="" prop="code" :rules="[]">
                            <div>
                                <el-input placeholder="谷歌验证码" v-model="scoreForm.code">
                                    <template slot="prepend">验证码</template>
                                </el-input>
                            </div>
                        </el-form-item>

                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="scoreVisible = false">取 消</el-button>
                    <el-button type="primary" size="small" @click="submitScoreForm('scoreForm')">确 定</el-button>
                </div>
            </el-dialog>
        </div>

        <!--添加充值订单-->
        <div class="dialog">
            <el-dialog title="代理充值"
                       :visible.sync="rechargeVisible"
                       custom-class="common-dialog"
                       :close-on-click-modal="false"
                       @close="rechargeVisibleClose('rechargeForm')"
                       width="30%">
                <div class="dialog_body">
                    <el-form label-position="right" status-icon label-width="70px"
                             :model="rechargeForm" ref="rechargeForm">
                        <!--<el-form-item label="ID" prop="agentId" :rules="[{message: 'ID不能为空', trigger: 'blur', required: true}]">
                            <el-input placeholder="ID" v-model="rechargeForm.agentId" :style="'pointer-events: none;'"/>
                        </el-form-item>-->
                        <el-form-item label="代理" prop="username" :rules="[{message: '代理不能为空', trigger: 'blur', required: true}]">
                            <el-input placeholder="代理" v-model="rechargeForm.username" :style="'pointer-events: none;'"/>
                        </el-form-item>
                        <el-form-item label="金额" prop="amount" :rules="[{message: '金额不能为空', trigger: 'blur', required: true}]">
                            <el-input placeholder="金额" v-model="rechargeForm.amount"/>
                        </el-form-item>
<!--                        <el-form-item label="验证码" prop="code" :rules="[{message: '验证码不能为空', trigger: 'blur', required: true}]">
                            <el-input placeholder="谷歌验证码" v-model="rechargeForm.code"/>
                        </el-form-item>-->
                        <el-form-item label="说明" prop="explain" :rules="[]">
                            <el-input type="textarea"
                                      size="medium"
                                      autosize
                                      placeholder="说明"
                                      v-model="rechargeForm.expound"
                                      clearable>
                            </el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="rechargeVisible = false">取 消</el-button>
                    <el-button type="primary" size="small" @click="submitRechargeForm('rechargeForm')">确 定</el-button>
                </div>
            </el-dialog>
        </div>

    </div>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    import message from "../../utils/message";

    export default {
        name: "ProxyWallet",
        components: {CommonTable},
        data(){
            return{
                scoreVisible: false,
                scoreForm: {
                    id: '',
                    agentId: '',
                    username: '',
                    current: '',
                    score: 0,
                    type: '',
                    code: ''
                },
                rechargeVisible: false,
                rechargeForm: {
                    agentId: '',
                    username: '',
                    amount: '',
                    expound: '',
                    code: ''
                },
                searchs:[
                    {
                        name: 'agentId',
                        placeholder: '代理',
                        type: 'select',
                        selectUrl: '/agent/getAll',
                        selectData: [],
                    }, {
                        name: 'parentName',
                        placeholder: '上级',
                        type: 'input'
                    },
                    {
                        name: 'startTime',
                        placeholder: '开始时间',
                        type: 'dateTime'
                    },
                    {
                        name: 'endTime',
                        placeholder: '结束时间',
                        type: 'dateTime'
                    }
                ],
                permission:{
                    add: 'proxyWallet:add',
                    update: 'proxyWallet:update',
                    delete: 'proxyWallet:delete',
                    deleteBatch: 'proxyWallet:deleteBatch'
                },
                url: {
                    get: '/proxyWallet/listByCondition',
                    add: '/proxyWallet/add',
                    update: '/proxyWallet/update',
                    delete: '/proxyWallet/delete/',
                    delete_batch: '/proxyWallet/deleteBatch',
                },
                tableColumns: [
                    {
                        field: 'id',
                        label: 'ID',
                        show: true,
                        width: '100',
                    },{
                        field: 'agentId',
                        label: '代理',
                        selectUrl: '/agent/getAll',
                        selectData: [],
                        show: {
                            type: 'select'
                        },
                        width: '',
                    },{
                        field: 'address',
                        label: '收款地址钱包',
                        show: true,
                        width: '',
                    },{
                        field: 'score',
                        label: '积分',
                        show: true,
                        width: '',
                    },{
                        field: 'balance',
                        label: '余额',
                        show: true,
                        width: '',
                    }/*,{
                        field: 'participate',
                        label: '参与计算',
                        show: {
                            type: 'tag',
                            tags:[{
                                key: 1,
                                value: ' 是 ',
                                type: 'primary'
                            },{
                                key: 0,
                                value: ' 否 ',
                                type: 'warning'
                            }]
                        },
                        width: '80px',
                    }*/, {
                        field: 'participate',
                        label: '参与计算',
                        show: {
                            type: 'status',
                            url: '/proxyWallet/update'
                        },
                        values: [{
                            type: 'primary',
                            key: 1,
                            value: '参与',
                            confirm: (agentId) => {
                                let username = agentId;
                                this.tableColumns[1].selectData.some(item => {
                                    if (item.id === agentId) {
                                        username = item.name
                                        return true
                                    }
                                })
                                return `是否将代理 ${username} 的参与计算从避开改为参与?`
                            }
                        }, {
                            type: 'warning',
                            key: 0,
                            value: '避开',
                            confirm: (agentId) => {
                                let username = agentId;
                                this.tableColumns[1].selectData.some(item => {
                                    if (item.id === agentId) {
                                        username = item.name
                                        return true
                                    }
                                })
                                return `是否将代理 ${username} 的参与计算从参与改为避开?`
                            }
                        }],
                        width: '80px',
                        confirm: 'agentId',
                        permission: 'proxyWallet:update'
                    },{
                        field: 'createTime',
                        label: '创建时间',
                        show: true,
                        width: '',
                    }
                ],
                formFields: {
                    addTitle: '创建收款钱包',
                    updateTitle: '修改收款钱包',
                    labelWidth: '90px',
                    model: [{
                        field: 'agentId',
                        label: '代理',
                        type: 'select',
                        selectUrl: '/agent/getAll',
                        selectData: [],
                        placeholder: '请选择',
                        rules: [{
                            message: '请选择代理', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }, {
                        field: 'participate',
                        label: '参与计算',
                        type: 'select',
                        selectData: [{
                            id: 1,
                            name: '参与',
                        }, {
                            id: 0,
                            name: '避开',
                        }],
                        placeholder: '请选择',
                        rules: [{
                            message: '请选择', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                        default: 1
                    }],
                },
                operate: [{
                    icon: 'el-icon-edit-outline',
                    type: 'text',
                    text: '修改积分',
                    handle: (row) => {
                        const agentList = this.formFields.model[0].selectData;
                        agentList.forEach(item => {
                            if (item.id === row.agentId) {
                                this.scoreForm.username = item.name;
                            }
                        })
                        this.scoreForm.id = row.id;
                        this.scoreForm.agentId = row.agentId;
                        this.scoreForm.current = row.score;
                        this.scoreForm.code = '';
                        this.scoreVisible = true;
                    }
                }, {
                    icon: 'el-icon-discount',
                    type: 'text',
                    text: '积分充值',
                    handle: (row) => {
                        const agentList = this.formFields.model[0].selectData;
                        agentList.forEach(item => {
                            if (item.id === row.agentId) {
                                this.rechargeForm.username = item.name;
                            }
                        })
                        this.rechargeForm.agentId = row.agentId;
                        this.rechargeForm.code = '';
                        this.rechargeVisible = true;
                    }
                }, {
                    icon: 'el-icon-files',
                    type: 'text',
                    text: '查询余额',
                    exist: () => {
                        return this.$refs.table.havePermission('proxyWallet:search:balance')
                    },
                    handle: (row) => {
                        this.$axios.post({
                            url: '/proxyWallet/search/balance/' + row.id,
                            success: (res) => {
                                if(res.code === 0){
                                    this.$set(row, 'balance', res.data);
                                }else{
                                    this.$message.error('查询余额失败');
                                }
                            }
                        });
                    }
                }, {
                    icon: 'el-icon-files',
                    type: 'text',
                    text: '更换钱包',
                    exist: () => {
                        return this.$refs.table.havePermission('proxyWallet:updateAddress')
                    },
                    handle: (row) => {
                        this.$axios.post({
                            url: '/proxyWallet/updateAddress/' + row.id,
                            success: (res) => {
                                if(res.code === 0){
                                    this.$message.success('操作成功');
                                    this.$refs.table.getData();
                                }else{
                                    this.$message.error('操作失败');
                                }
                            }
                        });
                    }
                }]
            }
        },
        methods:{
            scoreVisibleClose(formName) {
                this.$refs[formName].resetFields();
            },
            submitScoreForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (!this.scoreForm.type) {
                            this.$message.error("请选择类型")
                            return;
                        }
                        if (this.scoreForm.score <= 0) {
                            this.$message.error("请输入大于0的积分")
                            return;
                        }
                        this.$axios.post({
                            url: '/proxyWallet/updateScore',
                            data: this.scoreForm,
                            confirm: '确定进行该操作?',
                            success: (res) => {
                                if (res.code === 0) {
                                    this.$message.success('积分修改成功');
                                    this.$refs.table.getData();
                                    this.scoreVisible = false;
                                } else {
                                    this.$message.error(res.msg || '积分修改失败');
                                }
                            }
                        })
                    }
                })
            },
            submitRechargeForm (formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$axios.post({
                            url: '/agentRecharge/manual/add',
                            data: this.rechargeForm,
                            success: (res) => {
                                if (res.code === 0) {
                                    this.$refs.table.getData();
                                    message.success('添加充值订单成功');
                                    this.rechargeVisible = false;
                                } else {
                                    message.error(res.msg || "添加充值订单失败");
                                }
                            }
                        });
                    }
                })
            },
            rechargeVisibleClose(formName) {
                this.$refs[formName].resetFields();
            },
        }
    }
</script>

<style scoped>
    .input-with-select {
        background-color: #fff;
    }
</style>
